import configLocal from './configLocal';
import configPrePROD from './configPrePROD';
import configProd from './configPROD';
import configUAT from './configUAT';

let config;
if (process.env.REACT_APP_DEPLOY_ON === 'LOCAL') {
  config = configLocal;
} else if (process.env.REACT_APP_DEPLOY_ON === 'UAT') {
  config = configUAT;
} else if (process.env.REACT_APP_DEPLOY_ON === 'PROD') {
  config = configProd;
} else if (process.env.REACT_APP_DEPLOY_ON === 'PREPROD') {
  config = configPrePROD;
} else {
  config = configLocal;
}

export default config;
